import { useSnapshot } from 'valtio'
import cn from 'classnames'
import { type ReactElement } from 'react'
import { PlaceholderBox } from '../../../../../../../shared/components/ui/PlaceholderBox'
import { ErrorBox } from '../../../../../../../shared/components/ui/ErrorBox'
import { proxyGlobalAuth } from '../../../../../../../shared/proxies/proxyGlobalAuth'
import { rpOccurrenceProxy } from '../../rpOccurrenceProxy'
import { RpOccurrenceRelatedTransactionsTableHeader } from './RpOccurrenceRelatedTransactionsTableHeader'
import { RoOccurrenceRelatedTransactionRows } from './RoOccurrenceRelatedTransactionsRows'

export function RpOccurrenceRelatedTransactionsTable (): ReactElement | null {
  const { apiCall, rpOccurrence } = useSnapshot(rpOccurrenceProxy)
  const { siteTheme: { tableHeaderColors } } = useSnapshot(proxyGlobalAuth)

  if (!rpOccurrence?.transactions) {
    return (<></>)
  }

  return (

    <PlaceholderBox loading={apiCall.loading} rows={40} rowHeight="h-5">
      <ErrorBox error={apiCall.error}>
        <div className={cn('flex flex-row shadow rounded p-4')}>
          <h2 className={cn(tableHeaderColors.secondaryFontClasses, 'text-xl text-left')}>
            Transactions
          </h2>
        </div>
        <table className="w-full">
          <thead className="text-left">
            <tr>
              <RpOccurrenceRelatedTransactionsTableHeader title="ID" width={10} />
              <RpOccurrenceRelatedTransactionsTableHeader title="Date" width={10} />
              <RpOccurrenceRelatedTransactionsTableHeader title="Method" width={15} />
              <RpOccurrenceRelatedTransactionsTableHeader title="Type" width={15} />
              <RpOccurrenceRelatedTransactionsTableHeader title="Status" width={15} />
              <RpOccurrenceRelatedTransactionsTableHeader title="Amount" width={15} />
              <RpOccurrenceRelatedTransactionsTableHeader title="Action" width={20} />

            </tr>
          </thead>

          <tbody>
            <RoOccurrenceRelatedTransactionRows />
          </tbody>
        </table>
        {/*<RpOccurrencesTableFooter />*/}
      </ErrorBox>
    </PlaceholderBox>
  )
}
